import clsx from 'clsx';
import { IAnyType } from 'common/types/common';
import { normalizeLocalizedHtml } from 'common/utils/url';
import { useTranslation } from 'next-i18next';

interface Props {
  content: IAnyType;
  title: string;
}

export const LegalContent: React.FC<Props> = ({ content, title }) => {
  const { i18n } = useTranslation();
  const normalizeHtml = (value: string) => normalizeLocalizedHtml(value, i18n.language);

  const renderContent = (item: IAnyType, index: number) => {
    if (item.type === 'h2') {
      return (
        <h2
          key={`content-${index}`}
          className={clsx('heading-2 mb-4 mt-20 font-semibold lg:mb-8', item.className)}
          dangerouslySetInnerHTML={{ __html: normalizeHtml(item.value) }}
        />
      );
    }
    if (item.type === 'h3') {
      return (
        <h2
          key={`content-${index}`}
          className={clsx('heading-3 mb-4 mt-16 font-semibold', item.className)}
          dangerouslySetInnerHTML={{ __html: normalizeHtml(item.value) }}
        />
      );
    }
    if (item.type === 'paragraph') {
      return (
        <p
          key={`content-${index}`}
          className={clsx('mb-6 mt-2 max-w-full', item.className)}
          dangerouslySetInnerHTML={{ __html: normalizeHtml(item.value) }}></p>
      );
    }
    if (item.type === 'ul') {
      return (
        <ul key={`content-${index}`} className={clsx('list-disc pl-4', item.className)}>
          {item.content.map((li: IAnyType, listIndex: number) => (
            <li
              key={`list-${listIndex}`}
              className="mt-3 max-w-full"
              dangerouslySetInnerHTML={{ __html: normalizeHtml(li.value) }}
            />
          ))}
        </ul>
      );
    }

    if (item.type === 'centered') {
      return (
        <p
          key={`content-${index}`}
          className={clsx(
            'mb-16 mt-20 max-w-full bg-white/10 p-10 text-center font-semibold italic',
            item.className,
          )}
          dangerouslySetInnerHTML={{ __html: normalizeHtml(item.value) }}
        />
      );
    }
    return <></>;
  };

  if (!content?.length) {
    return <></>;
  }
  return (
    <section className="bg-gradient flex min-h-[100vh] w-full items-center overflow-hidden p-5 pb-20 pt-48">
      <div className="mx-auto max-w-[900px]">
        <h1 className="heading-1 mb-16 font-bold">{title}</h1>

        {content.map(renderContent)}
      </div>
    </section>
  );
};
